/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<fdbe8a954993b5a8410822a359ca747d>>
 * @relayHash 59cc69d8f3e601f4e0c2726297919a45
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ef93492d24e06237093ece305e6b5b3484eefce990d439e5a6ed0767583de2ed

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_virtualAgentConversationQuery$variables = Record<PropertyKey, never>;
export type ui_virtualAgentConversationQuery$data = {
  readonly me: {
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"conversationHelpseeker">;
    } | null | undefined;
  };
};
export type ui_virtualAgentConversationQuery = {
  response: ui_virtualAgentConversationQuery$data;
  variables: ui_virtualAgentConversationQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ui_virtualAgentConversationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "conversationHelpseeker"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ui_virtualAgentConversationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ef93492d24e06237093ece305e6b5b3484eefce990d439e5a6ed0767583de2ed",
    "metadata": {},
    "name": "ui_virtualAgentConversationQuery",
    "operationKind": "query",
    "text": null
  }
};

(node as any).hash = "c8123d2a415ab12b36be00497ac6def6";

export default node;
